
    import { isDev } from "./../../helpers/index"
    import { login } from "./../../api/auth-data.service"
    import authConfig from "./../../api/auth-config.development"
    import { defineComponent } from "vue"
    import { saveToken } from "@/api/auth-utility.service"

    export default defineComponent({
        components: {

        },
        data() {
            return {
                isDev,
                password: "",
                email: "",

            }
        },
        computed: {

        },
        methods: {
            async submit() {
                try {
                    const token = await login(this.email, this.password)
                    saveToken(token.token)
                    location.reload()
                } catch (e) {
                    console.log(e)
                }
            },
            async authOpen(provider: string) {
                try {
                    const providerConfig = authConfig.providers[provider]
                    const endpointUrl = providerConfig.authorizationEndpoint
                    const target = authConfig.platform === "mobile" ? "_self" : provider // you can perhaps look at the screen size to know it's a mobile?
                    const popupSizes = {
                        height: providerConfig?.popupSize?.height || 800,
                        width: providerConfig.popupSize?.width || 800,
                    };

                    (this.$root as any)?.popupService.open(endpointUrl, target, popupSizes)

                    // Desktop
                    const token = await (this.$root as any)?.popupService.pollPopup()
                    saveToken(token)
                    location.reload()
                } catch (error) {
                    console.log(error)
                }
            }
        },
    })

    